import React, { useMemo } from "react";
import cx from "classnames";
import parseDate from "utils/parseDate";
// Styles
import styles from "components/Shared/EventCard/EventCard.module.scss";
// Components
import Button from "components/Button";

function EventCard({ details, isRSVPd }) {
  const { startdate, spotsRemaining, displayOnly } = useMemo(() => {
    const startdate = details.start_date ? parseDate(details.start_date) : {};
    const attendeesCount = details.attendees ? details.attendees.length : 0;
    const spotsRemaining = details.attendees_limit - attendeesCount;
    const displayOnly = details.link ? details.link : true;
    return { startdate, spotsRemaining, displayOnly };
  }, [details]);

  return (
    <a
      aria-label={`${details.name} event details`}
      href={displayOnly && `/event/${details._id && details._id}`}
      className={cx(styles.eventcard, {
        [styles.eventcard__isCancelled]: details.cancelled == true,
      })}
    >
      {details.cancelled && (
        <svg
          className={styles.eventcard__cancelledFlag}
          width="108"
          height="77"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            y="55"
            width="110"
            height="25"
            rx="6"
            transform="rotate(-30 0 55)"
            fill="#DD5D39"
          />
          <path
            d="M22.043 54.758l-1.883 1.808c-.39-.486-.813-.802-1.268-.95-.46-.154-.96-.076-1.5.236-.624.36-.978.855-1.065 1.485-.086.63.09 1.325.527 2.083.43.743.922 1.25 1.477 1.519.56.257 1.166.198 1.819-.18.593-.342.928-.775 1.005-1.3.077-.525-.013-1.089-.27-1.69l2.435-.956c.196.547.308 1.088.336 1.622a4.163 4.163 0 0 1-.204 1.544 4.16 4.16 0 0 1-.802 1.394c-.37.433-.851.821-1.444 1.164-.751.433-1.454.689-2.11.767a4.02 4.02 0 0 1-1.798-.177 4.212 4.212 0 0 1-1.483-.93 7.067 7.067 0 0 1-1.156-1.51 5.582 5.582 0 0 1-.666-1.777 4.57 4.57 0 0 1 .03-1.819 4.41 4.41 0 0 1 .78-1.666c.395-.528.927-.985 1.595-1.371.563-.325 1.11-.54 1.639-.646a4.017 4.017 0 0 1 1.51-.061c.47.069.917.226 1.34.472.417.24.803.552 1.156.939zm4.979 4.27l-1.66-9.999 2.33-1.346 7.841 6.431-2.173 1.255-1.32-1.144-3.175 1.833.33 1.716-2.173 1.255zm.89-7.869l.616 3.172 2.173-1.254-2.462-2.106-.54-.545.213.733zM36.847 46l3.185 5.517-2.049 1.183-4.745-8.219 2.59-1.495 5.872 3.905.584.519-.519-.796-3.055-5.292 2.049-1.183 4.745 8.219-2.477 1.43-6.134-4.1-.65-.525.604.837zm16.57-9.356l-1.883 1.808c-.39-.485-.813-.802-1.269-.95-.46-.154-.96-.076-1.5.236-.623.36-.977.855-1.064 1.486-.086.63.09 1.324.527 2.082.43.743.922 1.25 1.477 1.519.56.258 1.166.198 1.819-.18.592-.341.928-.775 1.005-1.3.077-.525-.013-1.088-.27-1.69l2.435-.956c.196.547.308 1.088.336 1.622a4.162 4.162 0 0 1-.204 1.544 4.16 4.16 0 0 1-.802 1.394c-.37.434-.852.822-1.444 1.164-.751.433-1.454.689-2.11.767a4.02 4.02 0 0 1-1.798-.177 4.212 4.212 0 0 1-1.483-.93 7.07 7.07 0 0 1-1.156-1.51 5.585 5.585 0 0 1-.666-1.777 4.573 4.573 0 0 1 .03-1.819 4.41 4.41 0 0 1 .78-1.665c.395-.529.927-.986 1.595-1.372.563-.325 1.11-.54 1.639-.646a4.017 4.017 0 0 1 1.51-.061 3.7 3.7 0 0 1 1.34.473 4.78 4.78 0 0 1 1.156.938zm5.852 3.766l-4.744-8.218 6.316-3.647 1.007 1.745-4.267 2.464.917 1.587 3.298-1.904.865 1.497-3.299 1.905.936 1.62 4.357-2.515 1.02 1.768-6.405 3.698zm9.33-5.386l-4.745-8.219 2.161-1.247 3.608 6.248 3.906-2.256 1.138 1.97-6.068 3.504zm8.922-5.151l-4.745-8.219 6.316-3.646 1.008 1.745-4.267 2.463.916 1.588 3.299-1.905.864 1.497-3.298 1.905.936 1.621 4.357-2.515 1.02 1.767-6.406 3.699zm9.33-5.387l-4.746-8.218 3.153-1.82c1.403-.81 2.682-1.083 3.835-.819 1.15.258 2.101 1.04 2.855 2.345.351.608.58 1.221.687 1.84.107.619.089 1.22-.055 1.803-.147.576-.431 1.125-.85 1.647-.416.51-.973.967-1.671 1.37l-3.209 1.852zm-.755-8.195l-.878.506 2.75 4.763.957-.553c.773-.446 1.218-.993 1.334-1.64.116-.648-.046-1.355-.488-2.12-.464-.804-.993-1.279-1.589-1.425-.587-.151-1.282.005-2.086.469z"
            fill="#fff"
          />
        </svg>
      )}

      <div className={styles.eventcard__date}>
        <p>
          {startdate.month}
          <br />
          <span>{startdate.day}</span>
        </p>
        <div className={styles.eventcard__date__icon}>
          {details.type === "Book club" && (
            <img src="/icons/bookclub-icon-black.svg" alt="book club" />
          )}
          {details.type === "Cookbook club" && (
            <img src="/icons/cookbook-icon-black.svg" alt="Cookbook club" />
          )}
          {details.type !== "Book club" && details.type !== "Cookbook club" && (
            <img src="/icons/othergathering-icon-black.svg" alt="couch" />
          )}
        </div>
      </div>

      <div className={styles.eventcard__info}>
        <h3>
          {details.venue_type === "Virtual" ? (
            <>
              <span className={styles.virtualFlag}>Virtual</span> {details.type}
            </>
          ) : (
            <>{details.type}</>
          )}
        </h3>
        <h4>{details.name && details.name}</h4>
        <p>
          <span>
            {startdate.dayOfWeek}{" "}
            {`${startdate.hour && startdate.hour}:${
              startdate.minutes === 0 ? "00" : startdate.minutes
            }${startdate.ampm && startdate.ampm}`}{" "}
            {startdate.timeZone && startdate.timeZone}
          </span>
          {details.venue_type !== "Virtual" && (
            <>
              {details.neighborhood && ` • ${details.neighborhood},`}{" "}
              {details.community && details.community}
            </>
          )}
        </p>
        <p>{details.description}</p>
      </div>

      <div className={styles.eventcard__host}>
        <div
          className={styles.eventcard__host__image}
          style={{
            backgroundImage: `url('${
              details.host.hostImage
                ? details.host.hostImage + "?w=150&h=150&fit=max"
                : "/placeholder/placeholder-profile-image.png"
            }')`,
          }}
        >
          <svg
            className={styles.eventcard__host__checkmark}
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="13" cy="13" r="13" fill="#F4BF84" />
            <path
              d="M19 10.42L17.59 9L11 15.59L8.42 13.02L7 14.43L11 18.42L19 10.42Z"
              fill="#274C4A"
            />
          </svg>

          <svg
            className={styles.eventcard__host__roletitle}
            width="56"
            height="52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.588 22.316L5.09 11.504l2.77-.128.2 4.34 4.043-.186-.2-4.34 2.77-.127.497 10.812-2.77.128-.206-4.488-4.044.186.207 4.487-2.77.128zM23.098 24.06c-.86-.296-1.565-.693-2.114-1.19-.55-.498-.951-1.058-1.203-1.677a5.064 5.064 0 0 1-.362-1.999c.01-.713.14-1.429.387-2.148a6.318 6.318 0 0 1 1.041-1.908 5.194 5.194 0 0 1 1.573-1.332 4.948 4.948 0 0 1 2.01-.578c.741-.059 1.518.052 2.332.333.86.296 1.566.693 2.122 1.193.554.5.961 1.06 1.223 1.683.26.623.389 1.292.383 2.006a6.75 6.75 0 0 1-.38 2.151 6.622 6.622 0 0 1-1.032 1.927c-.44.564-.96 1.01-1.558 1.337a4.844 4.844 0 0 1-2.022.566c-.75.05-1.55-.071-2.4-.364zm.8-2.233c.804.277 1.503.22 2.098-.172.595-.39 1.055-1.058 1.38-2.002.328-.953.379-1.77.153-2.448-.226-.68-.731-1.154-1.516-1.425-.767-.264-1.456-.198-2.068.198-.612.396-1.08 1.065-1.405 2.009-.32.925-.376 1.727-.17 2.404.206.677.715 1.156 1.529 1.436zM31.37 25.286l2.882-.026a4.792 4.792 0 0 0 .274 1.718c.19.52.558 1.008 1.104 1.464.387.323.74.487 1.06.49a.947.947 0 0 0 .774-.348c.253-.303.259-.66.015-1.07-.243-.41-.663-.967-1.26-1.672a10.448 10.448 0 0 1-.93-1.232 3.96 3.96 0 0 1-.52-1.16 2.335 2.335 0 0 1 0-1.13c.092-.381.3-.764.623-1.151a3.03 3.03 0 0 1 1.044-.81c.403-.19.837-.285 1.3-.284.464.001.955.103 1.475.305.52.203 1.038.52 1.553.95.758.635 1.34 1.341 1.747 2.119.406.777.608 1.668.607 2.672l-2.829-.084a3.775 3.775 0 0 0-.187-1.626c-.177-.496-.524-.96-1.04-1.391-.41-.342-.775-.514-1.098-.513-.323.001-.573.107-.75.32-.248.295-.27.627-.07.995.202.369.587.875 1.157 1.518.822.958 1.356 1.834 1.603 2.625.246.793.045 1.576-.601 2.349-.64.766-1.447 1.144-2.42 1.136-.973-.008-1.955-.427-2.949-1.258-.947-.792-1.607-1.595-1.977-2.407a6.31 6.31 0 0 1-.587-2.5zM46.05 30.027l2.004-1.242 4.826 7.79-2.004 1.241-1.686-2.722-7.197 4.458-1.46-2.357 7.197-4.458-1.68-2.71z"
              fill="#8C93A0"
            />
          </svg>
        </div>
        <h4>{details.host && details.host.first_name}</h4>
        <p>Invites you</p>
      </div>

      <div className={styles.eventcard__rsvp}>
        {!details.cancelled && (
          <>
            {displayOnly && !isRSVPd && (
              <Button label="RSVP" visualOnly={true} />
            )}
            {isRSVPd && (
              <h4 className={styles.eventcard__rsvp__going}>You're Going</h4>
            )}
            <div className={styles.eventcard__attend__attendance}>
              <p>
                Members{" "}
                {details.guest_limit && details.guest_limit > 0
                  ? ` + ${details.guest_limit} Guest${
                      details.guest_limit > 1 ? "s" : ""
                    }`
                  : ``}
              </p>
            </div>
            <div className={styles.eventcard__attend__info}>
              {spotsRemaining <= 0 ? (
                <>No spots remaining</>
              ) : (
                <>
                  {spotsRemaining} / {details.attendees_limit} spots remaining
                </>
              )}
            </div>
          </>
        )}
      </div>
    </a>
  );
}

export default EventCard;
